<div>
  <a-input
    :value="value"
    :type="passwordType"
    size="large"
    :placeholder="placeholder"
    @change="onChange"
    :maxlength="20"
    autocomplete="off"
  >
    <template #prefix>
      <div class="password__prefix">
        <lock-outlined v-if="isLock"></lock-outlined>
        <unlock-outlined v-else></unlock-outlined>
      </div>
    </template>
    <template #suffix>
      <div class="password__suffix" @click.stop="togglePasswordType">
        <eye-invisible-outlined v-if="isLock"></eye-invisible-outlined>
        <eye-outlined v-else></eye-outlined>
      </div>
    </template>
  </a-input>
</div>
